import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var LineJustification = /** @class */ (function (_super) {
    __extends(LineJustification, _super);
    function LineJustification() {
        var _this = _super.call(this) || this;
        console.warn('[LineJustification] not implemented');
        return _this;
    }
    LineJustification.forceNativeConstructor = true;
    LineJustification.forceNativeMethods = true;
    // JS -> AS Bindings
    LineJustification.UNJUSTIFIED = 'unjustified';
    LineJustification.ALL_BUT_LAST = 'allButLast';
    LineJustification.ALL_INCLUDING_LAST = 'allIncludingLast';
    LineJustification.ALL_BUT_MANDATORY_BREAK = 'allButMandatoryBreak';
    return LineJustification;
}(ASObject));
export { LineJustification };
